export const imports = {
  'README.md': () =>
    import(/* webpackPrefetch: true, webpackChunkName: "readme" */ 'README.md'),
  'src/DataGrid/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-data-grid-index" */ 'src/DataGrid/index.mdx'
    ),
  'src/FoldCard/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-fold-card-index" */ 'src/FoldCard/index.mdx'
    ),
  'src/FooterToolbar/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-footer-toolbar-index" */ 'src/FooterToolbar/index.mdx'
    ),
  'src/Form/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-form-index" */ 'src/Form/index.mdx'
    ),
  'src/Future/export.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-future-export" */ 'src/Future/export.md'
    ),
  'src/GlobalFooter/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-global-footer-index" */ 'src/GlobalFooter/index.mdx'
    ),
  'src/Grid/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-grid-index" */ 'src/Grid/index.mdx'
    ),
  'src/Img/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-img-index" */ 'src/Img/index.mdx'
    ),
  'src/Label/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-label-index" */ 'src/Label/index.mdx'
    ),
  'src/Spin/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-spin-index" */ 'src/Spin/index.mdx'
    ),
  'src/PictureView/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-picture-view-index" */ 'src/PictureView/index.mdx'
    ),
  'src/Show/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-show-index" */ 'src/Show/index.mdx'
    ),
  'src/Transfer/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-transfer-index" */ 'src/Transfer/index.mdx'
    ),
  'src/Upload/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-upload-index" */ 'src/Upload/index.mdx'
    ),
  'src/hooks/index.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-hooks-index" */ 'src/hooks/index.md'
    ),
  'src/utils/ChangeContext.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-utils-change-context" */ 'src/utils/ChangeContext.mdx'
    ),
  'src/Form/Components/Cascader.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-form-components-cascader" */ 'src/Form/Components/Cascader.mdx'
    ),
  'src/Form/Components/Select.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-form-components-select" */ 'src/Form/Components/Select.mdx'
    ),
  'src/Form/Components/Utils/Layout.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-form-components-utils-layout" */ 'src/Form/Components/Utils/Layout.mdx'
    ),
  'src/Form/Components/Utils/ShowError.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-form-components-utils-show-error" */ 'src/Form/Components/Utils/ShowError.mdx'
    ),
}
